import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import WhyChoose from './components/WhyChoose';
import Features from './components/Features';
import UseCases from './components/UseCases';
import CTA from './components/CTA';
import Contact from './components/Contact';
import Footer from './components/Footer';
import SEO from './components/SEO';

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <SEO />
      <div className="min-h-screen">
        <Navigation />
        <Hero />
        <TrustBar />
        <WhyChoose />
        <Features />
        <UseCases />
        <CTA />
        <Contact />
        <Footer />
      </div>
    </HelmetProvider>
  );
};

export default App;
